<template>
	<div class="home">
        <div v-if="hasActiveSubscription" class="container-fluid">
            <div  class="row">
                <div class="col">
                    <h2 class="pt-4">Tu Revista del Mes</h2>
                    <MagazineView :year="2023" :month="9"></MagazineView>
                    <div class="bbmundo-book-banner">
                        <router-link :to="{ name: 'producto', params: {id: 68} }" class="text-light"><h3 class="py-4">Compra el Libro bbmundo</h3></router-link>
                    </div>
                </div>
            </div>
        </div>
		<div class="container" v-else>
			<div class="row">
				<div class="col">
					<div class="pt-4">
						<carousel
								:autoplay="true"
								:perPage="1"
								:autoplayTimeout="5000"
								:loop="true"
								>
								<slide v-for="slider in sliders" :key="slider.id">
								<router-link v-if="slider.name.includes('Libro') || slider.name.includes('libro')" :to="{ name: 'producto', params: {id: 68} }">
									<img
											class="img-fluid alta-mobile d-md-none"
											:src="slider.mobile_path"
											alt="Suscripciones"
											/>
									<img
											class="img-fluid baja-mobile d-md-none"
											:src="slider.mobile_path"
											alt="Suscripciones"
											/>
									<img
											class="img-fluid d-none d-md-block"
											:src="slider.desktop_path"
											alt="Suscripciones"
											/>
								</router-link>
						<router-link v-else-if="slider.name.includes('Álbum') || slider.name.includes('álbum')" :to="{ name: 'producto', params: {id: 93} }" >
							<img
									class="img-fluid alta-mobile d-md-none"
									:src="slider.mobile_path"
									alt="Suscripciones"
									/>
							<img
									class="img-fluid baja-mobile d-md-none"
									:src="slider.mobile_path"
									alt="Suscripciones"
									/>
							<img
									class="img-fluid d-none d-md-block"
									:src="slider.desktop_path"
									alt="Suscripciones"
									/>
						</router-link>
						<router-link v-else-if="slider.name.includes('Paqueteanuario') || slider.name.includes('paqueteanuario')" :to="{ name: 'producto', params: {id: 107} }" >
							<img
									class="img-fluid alta-mobile d-md-none"
									:src="slider.mobile_path"
									alt="Suscripciones"
									/>
							<img
									class="img-fluid baja-mobile d-md-none"
									:src="slider.mobile_path"
									alt="Suscripciones"
									/>
							<img
									class="img-fluid d-none d-md-block"
									:src="slider.desktop_path"
									alt="Suscripciones"
									/>
						</router-link>
						<router-link v-else-if="slider.name.includes('Suscripcion Abril 2024') || slider.name.includes('suscripcion abril 2024')" :to="{ name: 'producto', params: {id: 113} }">
							<img
									class="img-fluid alta-mobile d-md-none"
									:src="slider.mobile_path"
									alt="Suscripciones"
									/>
							<img
									class="img-fluid baja-mobile d-md-none"
									:src="slider.mobile_path"
									alt="Suscripciones"
									/>
							<img
									class="img-fluid d-none d-md-block"
									:src="slider.desktop_path"
									alt="Suscripciones"
									/>
						</router-link>
						<router-link v-else-if="slider.name.includes('Anuario') || slider.name.includes('anuario')" :to="{ name: 'producto', params: {id: 105} }" >
							<img
									class="img-fluid alta-mobile d-md-none"
									:src="slider.mobile_path"
									alt="Suscripciones"
									/>
							<img
									class="img-fluid baja-mobile d-md-none"
									:src="slider.mobile_path"
									alt="Suscripciones"
									/>
							<img
									class="img-fluid d-none d-md-block"
									:src="slider.desktop_path"
									alt="Suscripciones"
									/>
						</router-link>
						<router-link v-else-if="slider.name.includes('Premium') || slider.name.includes('premium')" :to="{ name: 'producto', params: {id: 80} }">
							<img
									class="img-fluid alta-mobile d-md-none"
									:src="slider.mobile_path"
									alt="Suscripciones"
									/>
							<img
									class="img-fluid baja-mobile d-md-none"
									:src="slider.mobile_path"
									alt="Suscripciones"
									/>
							<img
									class="img-fluid d-none d-md-block"
									:src="slider.desktop_path"
									alt="Suscripciones"
									/>
						</router-link>
						<router-link v-else :to="{ name: 'producto', params: {id: 1} }">
							<img
									class="img-fluid alta-mobile d-md-none"
									:src="slider.mobile_path"
									alt="Suscripciones"
									/>
							<img
									class="img-fluid baja-mobile d-md-none"
									:src="slider.mobile_path"
									alt="Suscripciones"
									/>
							<img
									class="img-fluid d-none d-md-block"
									:src="slider.desktop_path"
									alt="Suscripciones"
									/>
						</router-link>
								</slide>
						</carousel>
					</div>
				</div><!-- .col -->
			</div><!-- .row -->
		</div><!-- .container -->
		<section class="section pt-3">
			<div class="container">
				<div class="row mb-5">
					<loading :active.sync="is_loading"></loading>
					<ProductList :no_product="message" :products="products"></ProductList>
				</div>
			</div>
		</section>

	</div>
</template>


<script>
// @ is an alias to /src
import ProductList from "@/components/ProductList.vue";
import MagazineView from "@/components/Magazine/MagazineView.vue";
import Loading from "vue-loading-overlay";
import { Carousel, Slide } from "vue-carousel";
const axios = require("axios");

export default {
	name: "home",
	data() {
		return {
			api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
			base_url: process.env.VUE_APP_SUSCRIPTIONS_BASE_ROUTE,
			products: [],
			is_loading: true,
			message: "",
			sliders: [],
            userSubs: [],
            actualDate: null,
            hasActiveSubscription: false,
		};
	},
	filters: {
		fullUrl: function (file) {
			return "https://manager.mmkgroup.com.mx/images/" + file;
		},
	},
	components: {
		Carousel,
		Slide,
		Loading,
		ProductList,
        MagazineView,
	},
	mounted(){
        console.warn("Componente montado");
	},
	created() {
        console.warn("Componente creado");
        const date = new Date();
        const dateString = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
        )
            .toISOString()
            .split("T")[0];
        console.info("Año actual", date.getFullYear());
        console.info("Mes actual", date.getMonth()+1);

        this.actualDate = dateString;
		if ($cookies.isKey("ctoken")) {
			console.info("Se busca obtener los productos");
			this.getSubscriptions();
			this.getSlider();
		}
        if ($cookies.get("uidmmkg")){
            this.getUserSubscription();
        }else{
            console.error("No hay data para obtener suscripcion de usuario");
        }

	},
	methods: {
		baseUrlImage: function (file) {
			return this.base_url + "/storage/upload/" + file;
		},
        getUserSubscription(){
            var request_url = this.api_url+'/subscribers/'+$cookies.get("uidmmkg")+"/subscriptions";
            console.info("Obteniendo suscripciones", request_url);
            axios({
                method: 'GET',
                url: request_url,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer "+$cookies.get('utoken'),
                }
            }).then( (response) => {
                console.info("Respuesta de obtencion de suscripción");
                console.info(response);
                this.userSubs = response.data.data;

                if (this.userSubs[0].end_date > this.actualDate && this.userSubs[0].is_active && this.userSubs[0].payment.payment_status_id === 2){
                    this.hasActiveSubscription = true;
                    console.info("El usuario tiene una suscripción activa");
                }
            });
        },
		getProducts: function () {
			this.message = "Cargando productos";
			axios({
				method: "GET",
				url: this.api_url + "/products",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + $cookies.get("ctoken"),
				},
			})
				.then((response) => {
					this.products = response.data;
					// this.products.reverse();
					const elementoarray = this.products.pop();
					this.products.unshift(elementoarray);
					console.info("Se obtuvieron los productos");
					console.info(response.data);
					this.is_loading = false;
					if (this.products.length > 0)
						this.message = "Se obtuvieron los productos";
					else this.message = "No se encontraron productos que mostrar";
				})
				.catch((error) => {
					console.error(error);
					this.message = "No se encontraron productos que mostrar";
				});
		},
		getSlider: function () {
			axios({
				method: "GET",
				url: this.api_url + "/slider/month",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + $cookies.get("ctoken"),
				},
			})
				.then((response) => {
					this.sliders = response.data.sliders;
				})
				.catch((error) => {
					console.error(error);
				});
		},
		getSubscriptions: function () {
			axios({
				method: "GET",
				url: this.api_url + "/products/type/3",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + $cookies.get("ctoken"),
				},
			})
				.then((response) => {
					console.info("Respuesta de suscripciones");
					console.info(response.data);
					if (response.data.length > 0) this.products = response.data;
					this.is_loading = false;
					this.getPackages();
					this.getMerch();
				})
				.catch((error) => {
					console.error(error);
					this.message = "No se encontraron suscripciones que mostrar";
				});
		},
		getMerch: function () {
			axios({
				method: "GET",
				url: this.api_url + "/products/type/9",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + $cookies.get("ctoken"),
				},
			})
				.then((response) => {
					console.info("Respuesta de merch");
					if (response.data.length > 0)
						this.products = this.products.concat(response.data);
					console.info(this.products);
					this.is_loading = false;
				})
				.catch((error) => {
					console.error(error);
					this.message = "No se encontraron paquetes que mostrar";
				});
		},
		getPackages: function () {
			axios({
				method: "GET",
				url: this.api_url + "/products/type/4",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + $cookies.get("ctoken"),
				},
			})
				.then((response) => {
					console.info("Respuesta de paquetes");
					if (response.data.length > 0)
						this.products = this.products.concat(response.data);
					console.info(this.products);
					this.is_loading = false;
					this.getMagazines();
				})
				.catch((error) => {
					console.error(error);
					this.message = "No se encontraron paquetes que mostrar";
				});
		},
		getMagazines: function () {
			var year = new Date().getFullYear();
			axios({
				method: "GET",
				url: this.api_url + "/products/type/1/year/" + year,
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + $cookies.get("ctoken"),
				},
			})
				.then((response) => {
					console.info("Respuesta de revistas");
					if (response.data.length > 0)
						this.products = this.products.concat(response.data);
					console.info(this.products);
					this.is_loading = false;
					this.getLibros();
				})
				.catch((error) => {
					console.error(error);
					this.message = "No se encontraron revistas que mostrar";
				});
		},
		getLibros: function () {
			axios({
				method: "GET",
				url: this.api_url + "/products/type/5",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + $cookies.get("ctoken"),
				},
			})
				.then((response) => {
					console.info("Respuesta de libros");
					if (response.data.length > 0)
						this.products = this.products.concat(response.data);
					console.info(this.products);
					this.is_loading = false;
					this.getAnuarios();
					this.getSuscripcionesDigitales();
					this.getSpecialSubscriptions();
				})
				.catch((error) => {
					console.error(error);
					this.message = "No se encontraron libros que mostrar";
				});
		},
		getAnuarios: function () {
			axios({
				method: "GET",
				url: this.api_url + "/products/type/2",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + $cookies.get("ctoken"),
				},
			})
				.then((response) => {
					console.info("Respuesta de anuarios");
					if (response.data.length > 0)
						this.products = this.products.concat(response.data);
					console.info(this.products);
					this.is_loading = false;
				})
				.catch((error) => {
					console.error(error);
					this.message = "No se encontraron anuarios que mostrar";
				});
		},
		getSuscripcionesDigitales: function(){
			axios({
				method: "GET",
				url: this.api_url + "/products/type/6",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + $cookies.get("ctoken"),
				},
			})
				.then((response) => {
					console.info("Respuesta de suscripciones digitales");
					if (response.data.length > 0)
						this.products = this.products.concat(response.data);
					console.info(this.products);
					this.is_loading = false;
				})
				.catch((error) => {
					console.log(error);
					this.message = "No se encontraron suscripciones digitales que mostrar";
				})
		},
		getSpecialSubscriptions: function(){
			axios({
				method: "GET",
				url: this.api_url + "/products/type/7",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + $cookies.get("ctoken"),
				},
			})
				.then((response) => {
					console.info("Respuesta de suscripciones especiales");
					if (response.data.length > 0)
						this.products = this.products.concat(response.data);
					console.info(this.products);
					this.is_loading = false;
				})
				.catch((error) => {
					console.log(error);
					this.message = "No se encontraron suscripciones especiales que mostrar";
				})
		},
	},
};
</script>
<style>
.VueCarousel-dot{
	width: 20px !important;
	height: 20px !important;
}
</style>

<style scoped>
.home{
	min-height: 50vh;
}

@media (min-width: 200px) and (max-width: 361px) {
	.baja-mobile {
		display: block;
	}
	.alta-mobile {
		display: none;
	}
}
@media (min-width: 362px) {
	.baja-mobile {
		display: none;
	}
	.alta-mobile {
		display: block;
	}
}
.bbmundo-book-banner{
    background-color: #F2B05E
}
</style>
